import { render, staticRenderFns } from "./BrandActivity.vue?vue&type=template&id=18171420&scoped=true&"
import script from "./BrandActivity.vue?vue&type=script&lang=js&"
export * from "./BrandActivity.vue?vue&type=script&lang=js&"
import style0 from "./BrandActivity.vue?vue&type=style&index=0&id=18171420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18171420",
  null
  
)

export default component.exports